
import { homeConstants } from '../constants/home.constants'

const initState = {
  editBoardInfo: null,
}
export function editboardReducer(state = initState, action) {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
          return Object.assign({}, state, {
              editBoardInfo: null
          })
    case homeConstants.EDITBOARD_OPEN:
      return Object.assign({}, state, {
        editBoardInfo: action.editBoardInfo
      })
    case homeConstants.EDITBOARD_CLOSE:
      return Object.assign({}, state, {
        editBoardInfo: null
      })
    case homeConstants.TASKDIALOG_SELECT:
      return Object.assign({}, state, {
        editBoardInfo: action.editBoardInfo
      })
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/modules/editboard.reducer.js